import React, { useState, useEffect } from "react";
import { ReptoolModal } from "../utilities/ReptoolModal.tsx";
import { CollectionReptile } from "../collection/types/CollectionTypes.ts";
import { ListingPanel} from './ListingPanel.tsx';
import { useRepToolContext } from "../../RepToolContext.tsx";

export const EditListingModal = ({
  closeModal,
  onFinish,
  reptile
}: {
  closeModal: (sharingTurnedOn: boolean) => void;
  onFinish: () => void;
  reptile: CollectionReptile;
}) => {
  const [currentReptile, setCurrentReptile] = useState<CollectionReptile>(reptile);
  const { appendControls } = useRepToolContext();
  useEffect(() => {
    appendControls(null, 'Edit Listing Collection Reptile Modal');
  }, []);

  useEffect(() => {
    setCurrentReptile(reptile);
  }, [reptile]);

  return (
    <ReptoolModal id='select-collection-reptile-modal' title={`Edit Listing for ${currentReptile.name}`} closeModal={
      () => closeModal((window as any).currentUser.available_reptiles_visible)
    } body={
      <ListingPanel reptile={reptile}
      onRemoveListing={() => {
        onFinish();
        closeModal((window as any).currentUser.available_reptiles_visible);
      }}
      setReptile={(reptile) =>{
        onFinish();
        setCurrentReptile(reptile);
        closeModal((window as any).currentUser.available_reptiles_visible);
      }} readOnly={false} />
    } />
  )
}
